export default {
  data() {
    return {};
  },
  computed: {
    showNavigation() {
      // 从当前路由的元信息中获取是否显示底部导航栏
      return this.$route.meta.showNavigation !== false;
    }
  }
};